/**
 * A role as it is displayed. Looser than `MemberRole` on purpose: chat
 * messages carry the label they were sent with, which may name a role the
 * current directory no longer has.
 */
export interface RoleTag {
  slug: string;
  label: string;
}

/**
 * The teacher / curator / student tag.
 *
 * It is plain text rather than a colour-coded dot because the role is the
 * point: in a lesson it decides who is being asked and who is answering, and
 * that must not depend on remembering which colour means what. The label is
 * kept on one line — a wrapped two-line badge is what makes a chat row jump.
 */
export function RoleBadge({ role, small = false }: { role: RoleTag | null; small?: boolean }) {
  if (!role) return null;
  return <span className={`role-badge is-${role.slug} ${small ? 'is-small' : ''}`}>{role.label}</span>;
}
